import React from 'react'

import { LntCollapse, LntCollapsePanel } from '@app/components/base'

import styles from './styles.module.scss'

import type { ErrorModalContentProps } from './types'

export const ErrorModalContent: React.FC<ErrorModalContentProps> = ({ message, data }) => {
  if (!data || !Array.isArray(data)) return <>{ message }</>

  return (
    <LntCollapse className={ styles.errorModalContent }>
      { data.map(({ id, errors }) => {
        return (
          <LntCollapsePanel
            key={ id }
            header={ `ID: ${id}` }
          >
            <ol className={ styles.errorModalContent__errorsList }>
              { errors.map((error, index) => {
                return <li key={ `${id}_${error}_${index}` }>{ error }</li>
              }) }
            </ol>
          </LntCollapsePanel>
        )
      }) }
    </LntCollapse>
  )
}
